import { useEffect, useState } from 'react';

import InstagramSlides from '../Components/InstagramSlides';
import { useNotification } from '../Contexts/NotificationContext';

const HomeBlog = () => {
    const { setNotification } = useNotification();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/instagram/posts`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setPosts(data.images || []);
                } else {
                    throw new Error('Erro ao buscar os posts.');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return <InstagramSlides content={posts} title="Últimos do Instagram" loading={loading} />;
};

export default HomeBlog;
